<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasBottomLabel">Cookies</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body small">
    We use cookies to verify whether users are authenticated with our site. Authenticated users can create and save meal plans, while unauthenticated users cannot. By browsing this website, you agree to our use of cookies. <a class="link-opacity-100" href="/privacy_policy">Learn more.</a>
  </div>
</div>
